import type { AppEnvironmentType } from '../shared/types/app/AppEnvironmentType';

declare const APP_ENVIRONMENT_TYPE: AppEnvironmentType;

const getAppEnvironmentType = (): AppEnvironmentType => {
  return APP_ENVIRONMENT_TYPE;
};

export default getAppEnvironmentType;
